import React, { useState, useEffect } from "react";
import {
  Button,
  Row,
  Col,
  InputGroup,
  Input,
  ButtonGroup,
  Modal,
  FormGroup,
  Label,
} from "reactstrap";
import { Triangle } from "react-loader-spinner";
import toast from "react-hot-toast";
import CustomDataTable from "../../../Components/CustomTable/CustomTable";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DailyStatReportServices from "../../../services/OrderingServices/DailyStatReportServices";
import MasterOutletService from "../../../services/OrderingServices/MasterOutletService";
import OutletForm from "../component/OutletForm";
import DeleteModal from "../../../Components/Common/DeleteModal";

const customStyles = {
  headCells: {
    style: {
      fontSize: "0.92rem",
      fontWeight: 610,
    },
  },
  rows: {
    style: {
      fontSize: "0.9rem",
    },
  },
};

const MasterOutlet = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [filterText, setFilterText] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);
  const [formModalOpen, setFormModalOpen] = useState(false);
  const user = JSON.parse(localStorage.getItem("user"));
  const role = user?.user?.roles[0];
  console.log("🚀 ~ MasterOutlet ~ role:", role);
  const orgId = user?.organizationInfo?.id;
  const [isOpenDelete, setIsOpenDelete] = useState(false);

  const toggleFormModal = (item = null) => {
    setSelectedItem(item);
    setFormModalOpen(!formModalOpen);
  };

  const fetchConfigs = async () => {
    setLoading(true);
    try {
      const response = await MasterOutletService.getList(
        role === "OrgAdmin" ? orgId : null,
      );
      setData(response || []);
    } catch (error) {
      toast.error("Failed to fetch email configurations");
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchConfigs();
  }, []);
  const handleDeleteClick = (item) => {
    if (isOpenDelete) return;
    setSelectedItem(item);
    setIsOpenDelete(true);
  };

  const handleDelete = async () => {
    if (!selectedItem) return;

    try {
      await MasterOutletService.delete(selectedItem);
      toast.success("Outlet Deleted Successfully");
      fetchConfigs();
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to delete outlet");
    }
  };

  const columns = [
    {
      name: "S.N",
      selector: (row, index) => index + 1,
      width: "75px",
    },
    {
      name: "Code",
      selector: (row) => row.code || "N/A",
      sortable: true,
    },
    {
      name: "Name",
      selector: (row) => row.name || "-",
      sortable: true,
    },
    {
      name: "Address",
      selector: (row) => row.address,
      sortable: true,
    },
    {
      name: "Phone",
      selector: (row) => row.phone,
      sortable: true,
    },
    {
      name: "Is Default",
      selector: (row) => row.isDefault,
      cell: (row) => {
        return (
          <span
            className={`badge ${row.isDefault ? "bg-success" : "bg-danger"}`}
          >
            {row.isDefault ? "True" : "False"}
          </span>
        );
      },
      sortable: true,
    },
    {
      name: " Is Active",
      selector: (row) => row.isActive,
      cell: (row) => {
        return (
          <span
            className={`badge ${row.isActive ? "bg-success" : "bg-danger"}`}
          >
            {row.isActive ? "Active" : "Inactive"}
          </span>
        );
      },
      sortable: true,
    },
    {
      name: "Actions",

      cell: (row) => (
        <ButtonGroup>
          <Button
            color="info"
            size="sm"
            onClick={() => toggleFormModal(row)}
            title="Edit"
          >
            <i className="ri-edit-line" />
          </Button>

          <Button
            className="btn btn-soft-danger btn-sm"
            color="danger"
            onClick={() => handleDeleteClick(row.id)}
          >
            <i className="ri-delete-bin-5-line" />
          </Button>
          {/* <Button color="btn btn-soft-success" className="btn-sm">
            <i className="bx bx-show" />
          </Button> */}
        </ButtonGroup>
      ),
    },
  ];

  const filteredData = data.filter((row) =>
    `${row.code} ${row.name} ${row.address} ${row.phone}`
      .toLowerCase()
      .includes(filterText.toLowerCase()),
  );

  return (
    <div className="page-content">
      {" "}
      <div className="container-fluid">
        {" "}
        <BreadCrumb title="Master Outlet" pageTitle="Masters" />
        <Row className="mb-2">
          <Col md={8} xs={12}>
            <InputGroup>
              <Input
                placeholder="Search by code or name"
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
              />
            </InputGroup>
          </Col>
          <Col className="text-end">
            <Button color="success" onClick={() => toggleFormModal()}>
              <i className="bx bx-plus"></i> Create
            </Button>
          </Col>
        </Row>
        <CustomDataTable
          responsive
          striped
          pagination
          fixedHeader
          persistTableHead
          progressPending={loading}
          customStyles={customStyles}
          progressComponent={
            <div className="my-3">
              <Triangle visible={true} height="80" width="80" color="#5B71B9" />
              <h5 className="mt-1">Loading...</h5>
            </div>
          }
          columns={columns}
          data={filteredData}
        />
      </div>
      <OutletForm
        isOpen={formModalOpen}
        toggle={toggleFormModal}
        // onSubmit={handleFormSubmit}
        selectedItem={selectedItem}
        orgId={role === "OrgAdmin" ? orgId : null}
        fetchConfigs={fetchConfigs}
      />
      <DeleteModal
        show={isOpenDelete}
        onCloseClick={() => setIsOpenDelete(false)}
        onDeleteClick={handleDelete}
      />
    </div>
  );
};

export default MasterOutlet;
